import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';

export default function CheckboxInput<Name extends string | number>({
  label,
  checked,
  onUpdateField,
  name,
  onChange,
  disabled = false,
}: {
  disabled?: boolean;
  checked?: boolean;
  label?: string;
  name?: Name;
  onChange?: (b: boolean) => void;
  onUpdateField?: (name: Name, b: boolean) => void;
}) {
  return (
    <label className="cursor-pointer flex items-center gap-2 text-gray-dark ">
      <input
        disabled={disabled}
        name={name?.toString()}
        checked={!!checked}
        onChange={(_) => {
          onChange && onChange(_.target.checked);
          onUpdateField && name && onUpdateField(name, _.target.checked);
        }}
        type="checkbox"
        className="cursor-pointer form-checkbox  shadow-sm w-4 h-4 border-gray-100 text-green bg-white rounded focus:ring-0 focus:ring-offset-0 disabled:bg-gray-100 disabled:opacity-20"
      />
      {label}
    </label>
  );
}
